import {CSSProperties} from "react";

/**
 * Modal-Maße der Umbuchungs-Wizards: Tabellen-Steps brauchen die volle Breite,
 * Entscheidungs-Steps 1400: zwei Karten nebeneinander ohne Umbruch der Kursdaten (Abnahme 22.09.2026).
 */
export const TRANSFER_WIZARD_WIDTH_FULL = "calc(100% - 120px)";
export const TRANSFER_WIZARD_WIDTH_COMPACT = 1400;

export const transferWizardModalStyle: CSSProperties = {
    top: 30,
    padding: 0,
    maxWidth: TRANSFER_WIZARD_WIDTH_FULL,
    transition: "width 0.2s ease",
};
